import { Input } from 'Constants/styles';

import styled from '@emotion/styled';

export const BlueBtn = styled.button`
  padding: 0 20px;
  margin: 15px;
  background-color: var(--lp-colors-medium-blue-800);
  color: #fff;
  border: 1px solid var(--lp-colors-medium-blue-800);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  box-shadow: 0.5px 0.5px 3px 0.6px rgb(220 227 235 / 56%);
  width: auto;
  letter-spacing: 0.35px;
  cursor: pointer;
  font-weight: 400;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  height: 40px;

  &:disabled {
    opacity: 0.5;
  }
  &:first-of-type {
    margin-left: 0;
  }
`;

export const FormRow = styled.div`
  margin-bottom: 20px;
`;

export const TextInput = styled(Input)`
  padding-left: 10px;
`;

export const FormField = styled.div`
  position: relative;
`;

export const Label = styled.label`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 8px;
  display: block;
  color: #6c7488;
`;

export const Flex = styled.div`
  display: flex;
`;

export const FilterOptions = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 10px;
  display: flex;
  align-items: self-end;
  height: 20px;
  input {
    margin-right: 8px;
  }
`;

export const MessageWrapper = styled.div`
  padding: 60px 0;
`;

export const ReverseButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 20px;
`;

export const PayoutsDataTableContainer = styled.div`
  .hover-button-wrapper {
    visibility: hidden;
  }

  .rdt_TableRow:hover .hover-button-wrapper {
    visibility: visible;
  }
`;

export const EnableButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 20px;
`;

export const MerchantsDataTableContainer = styled.div`
  .hover-button-wrapper {
    visibility: hidden;
  }

  .rdt_TableRow:hover .hover-button-wrapper {
    visibility: visible;
  }
`;
